module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hAF7t"))).then(() => parcelRequire('5erN3'));